export default "__VITE_PUBLIC_ASSET__9e308666__"